import { observable } from "mobx";

import { SupportedMedicalData } from "../../../api";
import { ApiConnector } from "../../../api/api-connector";
import { fetchSupportedMedicalData } from "../../../catalogs/supported-medical-data";
import { DataAdd } from "../../../models/data-add";
import { getPrimaryUnitByName } from "../../../utils/data-utils";
import { getServerNowISO } from "../../../utils/server-time";
import { Patient } from "../patient";

export class AddAnyData extends DataAdd {
  @observable accessor supportedVariables: SupportedMedicalData[] = [];

  constructor(api: ApiConnector, patient: Patient) {
    super(api, patient);
    this.initFields = [
      "measurement_datetime",
      "measurement_type",
      "measurement_unit",
    ];
    this.desc = "Add (almost) any additional data";
    this.defaultDateTimeName = "Now";
    this.defaultDateTimeFields = ["measurement_datetime"];
    this.bodyField = "medical_data";
    this.endpoint = "medicaldata/bulk";
    this.reloadToTab = "any";
  }

  async initEmpty() {
    this.defaultDateTime = getServerNowISO();
    this.supportedVariables = await fetchSupportedMedicalData();
    this.addingList = [];
  }

  addItem() {
    this.addingList.push({
      measurement_datetime: this.defaultDateTime,
      measurement_type: null,
      measurement_value: null,
      measurement_unit: null,
    });
  }

  customSanitize(field: any) {
    field.measurement_unit = getPrimaryUnitByName(
      this.supportedVariables,
      field.measurement_type,
    );
    return field;
  }
}
